import { ProductsListItemResponseDto } from '@/apis/rest/generated/types'
import { ProductTypeDefinedByFrontend } from '@/types/product-type-defined-by.frontend'
import { getImageUrl } from '@/utils/utilURL'

export const transformProductListItemResponseDtoToProductCardData = (
  data: ProductsListItemResponseDto
): ProductTypeDefinedByFrontend => {
  const thumbnail = getImageUrl(data.mainImage?.path) || ''
  const sticker = getImageUrl(data.sticker)
  const isShowBundledMessage = !!data.maxOptionSkuCount && data.maxOptionSkuCount !== 1 && data.pricePerSku > 0
  const hasApplicableProductCoupon = !!data?.hasApplicableProductCoupon
  const hasDiscount = !!data.discountRate && data.discountRate > 0
  return {
    id: data.id,
    promotion: data.promotion,
    thumbnail,
    name: data.name,
    discountRate: data.discountRate || 0,
    price: data.price,
    salePrice: data.salePrice,
    reviewCount: data.review.count,
    reviewScore: data.review.score,
    maxOptionSkuCount: data.maxOptionSkuCount,
    pricePerSku: data.pricePerSku,
    isShowBundledMessage,
    // 쿠폰 적용 가능한 상품인지 확인, 나중에 백엔드 데이터에 맞게 변경
    hasApplicableProductCoupon,
    // 할인율이 0일때 안보여주기 위한 데이터
    // 할인율이 0이면 할인정보를 보여주지 않음(discountRate, price 가 안보여짐)
    hasDiscount,
    isLiked: data.isLiked,
    isRealSoldOut: data.isRealSoldOut,
    isNotAvailable: !!data.isSuspend,
    discountPrice: data.salePrice,
    supplyType: data.supplyType,
    thumbnailData: {
      // GraphQL, REST API 둘다 호환되게 하기 위해 추가 - 이벤트 트래커용
      price: data.price,
      discountRate: Number(data.discountRate),
      discountPrice: data.salePrice,
      reviewCount: data.review.count,
      reviewScore: data.review.score,
    },
    brand: {
      id: data.brand.id,
      name: data.brand.name,
    },
    categories: data.categories.map((category) => ({
      id: category.id,
      name: category.name,
    })),
    isPriceDown: data?.isPriceDown,
    sticker,
    expectedShippingFee: data.expectedShippingFee,
  }
}
